import { render, staticRenderFns } from "./CanvasImage.vue?vue&type=template&id=58ebcba6&scoped=true"
import script from "./CanvasImage.vue?vue&type=script&lang=js"
export * from "./CanvasImage.vue?vue&type=script&lang=js"
import style0 from "./CanvasImage.vue?vue&type=style&index=0&id=58ebcba6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ebcba6",
  null
  
)

export default component.exports